import { FormikValues } from 'formik'

import { useToast } from '@pnld/components-web'

import { useMutationUpdateMyAccount } from '@/api/users/account/mutations'
import { useQueryGetMyAccount } from '@/api/users/account/queries'
import { getErrorDetails } from '@/utils/error'

export const useMyAccountController = () => {
  const toast = useToast()

  const {
    data: myAccount,
    isLoading: isLoadingAccount,
    refetch,
  } = useQueryGetMyAccount({
    onError: error => {
      toast({
        title: 'Erro ao carregar dados do usuário',
        description: getErrorDetails(error),
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  const mutation = useMutationUpdateMyAccount({
    onSuccess: () => {
      toast({
        title: 'Perfil atualizado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      refetch()
    },
    onError: error => {
      toast({
        title: 'Erro ao atualizar perfil',
        description: getErrorDetails(error),
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  const noDataText = 'Não informado'

  const initialValues = {
    name: myAccount?.noUserName || noDataText,
    email: myAccount?.dsEmail || noDataText,
    perfil: myAccount?.profile.dsDescription || '',
    status: myAccount?.dsStatus || '',
  }

  const handleSubmit = (values: FormikValues) => {
    mutation.mutate({
      dsEmail: values.email,
    })
  }

  return {
    myAccount,
    isLoading: isLoadingAccount,
    initialValues,
    handleSubmit,
    isSubmitting: mutation.isLoading,
  }
}
